export var jsonParse = function (value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = {}; }
    try {
        return JSON.parse(value);
    }
    catch (error) {
        return defaultValue;
    }
};
